<template>
  <div>
    <section v-if="data.length > 0" class="hospitalsDetailSection">
      <ul class="hospitalsDetailEvent">
        <template v-for="event in data" :key="event.id">
          <EventCardHospital :event="event" />
        </template>
      </ul>
    </section>
  </div>
</template>

<script lang="ts">
import EventCardHospital from '@/components/block/EventCardHospital.vue'
import { defineComponent, PropType } from '@vue/runtime-core'
import { EventItem } from '@/types/Event'
export default defineComponent({
  components: {
    EventCardHospital
  },

  props: {
    data: {
      type: Array as PropType<EventItem[]>,
      default: () => []
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalsDetailEvent {
  @include mixins.mediaMax() {
    padding-left: 16px;
    padding-right: 16px;
    margin-top: -60px;
    margin-bottom: 60px;
  }
}
</style>
